import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import useStyles from './styles';

function TwoColumns({left, right}) {

  const classes = useStyles();

  return (
    <Grid container className={classes.grid}>
      <Grid item xs={12} md={4} className={classes.gridLeft}>
        <Paper className={classes.paper}>
          {left}
        </Paper>
      </Grid>
      <Grid item xs={12} md={8} className={classes.gridRight}>
        <Paper className={classes.paper}>
          {right}
        </Paper>
      </Grid>
    </Grid>
  );
}

export default React.memo(TwoColumns);
